export default __webpack_public_path__ + "static/down-974b8281fa80bd3a1e5aa82a0cb840b3.png";